export default __webpack_public_path__ + "images/3db8629391844f407c4e95ed77884653.svg";